import React, { useEffect, useState } from "react";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import Images from "../../Helpers/Images";
import { Link } from "react-router-dom";
import { BsChevronDoubleRight } from "react-icons/bs";
import CustomLoader from "./Loader/CustomLoader";

function FeaturedBox() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const getCollaborationsData = () => {
    let config = {
      url: ApiUrl.collaborationHub,
      method: "GET",
    };
    APIRequest(
      config,
      (res) => {
        setData(res?.data?.data);
        setIsLoading(false);
      },
      (err) => {
        console.log(err);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    getCollaborationsData();
  }, []);
  return (
    <>
      {isLoading ? (
        <CustomLoader visible={isLoading} />
      ) : (
        <div className="wish-featured-box">
          {data.map((item, e) => (
            <Link
              to="/campagin-detail"
              state={{ product: item, from: "featured" }}
              className="collab-product-box"
              key={e}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {/* {console.log("item", item)} */}
              <div className="collab-product-box-img">
                {/* <img src={Images.product1} alt="product" /> */}
                <img src={item?.campaign_logo_url} alt="product" />
              </div>
              <div className="collab-product-box-content">
                <div className="heading">
                  <h6 className="product-name">{item?.brand?.company_name}</h6>
                  <p className="p-title">{item?.campaign_title}</p>
                </div>
                <div className="list-wrapper">
                  {item?.campaign_platform !== null && (
                    <>
                      <div className="list-name">
                        <span>Followers</span>
                        <span className="title">
                          {
                            item?.campaign_platform[0]?.social_engagement_data
                              ?.follower
                          }
                          +
                        </span>
                      </div>
                      <div className="list-name">
                        <span>Engagement</span>
                        <span className="title">
                          {
                            item?.campaign_platform[0]?.social_engagement_data
                              ?.engagement
                          }
                          % +
                        </span>
                      </div>
                    </>
                  )}
                  <div className="list-name">
                    <span>Age</span>
                    <span className="title">
                      {item?.age?.min}-{item?.age?.max}+
                    </span>
                  </div>
                  {/* {console.log("item",item)} */}

                  <div className="list-name">
                    <span>Residence</span>
                    <div className="countryFlagBox">
                      {item?.countries?.map((country, index) => (
                        <img
                          className="countryFlag"
                          key={index}
                          src={
                            country?.flag_url
                              ? country.flag_url
                              : "/default-platform.png"
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <Link
                  to="/campagin-detail"
                  state={{ product: item, from: "featured" }}
                >
                  <button className="niche-btn">View Details</button>
                </Link>
              </div>
            </Link>
          ))}
        </div>
      )}
      <Link to="/collaboration-hub" className="see-more-btn featured-more-btn">
        See More <BsChevronDoubleRight />
      </Link>
    </>
  );
}

export default FeaturedBox;
